import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { TRequestDto } from './dto/RequestDto';

/**
 * Перевод заявок СП по шагам/Активирует (отключает) спецпредложение
 *
 * {@link https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/SpecOffer/322c05bdf608c90bd01d0a33dd929e2f Documentation}
 */
const update = (id: number, params: TRequestDto): IRequest => ({
    uri: '/v1/spec-offer/update',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    queryParams: { id },
    body: JSON.stringify(params),
});

export type { TRequestDto };
export type { TResponseDto } from './dto/ResponseDto';
export { ECategory } from './dto/ResponseDto';

export default update;
